<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='开启后将无法撤销，请谨慎操作；设置达到消费者达到等级一段时间后，是否执行掉级配置；不需要执行会员等级掉级的请不要开启；配置需点击保存生效' :padding='true'></SmallSquare>
    <a-card :bordered="false">
      <a-button @click="openseting" v-if="form.member_vip_card_type==0">开启有效期设置</a-button>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:3}" :wrapper-col="{span:11}" v-else>
        <a-form-item label="等级有效天数" name="expire_day_num" help="设置达到等级后，在有效天数内没有达到下一等级，需执行下面的惩罚，数字不能是负数和0">
          <a-input-number v-model:value="form.expire_day_num" style="width:100%" placeholder='365' :min='1' :precision='0' />
        </a-form-item>
        <a-form-item label="处理方式" name="amount">
              <a-radio-group name="radioGroup" v-model:value="form.expire_exec_type">
                <a-radio :value="1">扣除当前等级所需成长值</a-radio>
                <a-radio :value="2">成长值扣除至0</a-radio>
            </a-radio-group>
          <div class="ant-form-explain">扣除当前等级所需成长值：扣除用户当前等级的所需成长值，如消费者目前成长值200，当前等级所需成长值150，超过有效期后消费者剩余成长值50</div>
          <div class="ant-form-explain m-t-10">成长值扣除至0：超过有效期后，消费者剩余成长值0</div>
        </a-form-item>
       <a-form-item :wrapper-col="{offset:3}">
           <a-button v-has:setMemberDateSeting="save">保存</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted } from "vue";
import { Modal } from "ant-design-vue";
import {getPeriodOfValidity,setPeriodOfValidity} from '@/api/member'
import { iscode } from '../../../utils/app';
export default {
  setup() {
    const form = ref({
      expire_day_num:365,
      expire_exec_type:2,
      member_vip_card_type:2
    });
    const initData=async()=>{
      let result=await getPeriodOfValidity().then(res=>res.data).catch(error=>error)
      // console.log(result)
      form.value=result.data
      form.value.expire_exec_type = +form.value.expire_exec_type;
    }
    onMounted(()=>{
      initData()
    })
    const save=async ()=>{
      let result= await setPeriodOfValidity(form.value).then(res=>res.data).catch(error=>error)
      initData()
      iscode(result,true)
    }
    const openseting = () => {
      Modal.confirm({
        centered: true,
        content: "开启后将无法撤销，您是否开启有效期设置？",
        onOk: async () => {
         await setPeriodOfValidity({
          expire_day_num:365,
          expire_exec_type:form.value.expire_exec_type,
          member_vip_card_type:2
        }).then(res=>res.data).catch(error=>error)
          initData()
        },
      });
    };
    return {
      openseting,
      form,
      save
    };
  },
};
</script>